// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '@/styles/reset.css';
import '@/styles/common.css';
import './assets/icon/iconfont.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Router from 'vue-router'
import _axios from '@/ws/domain.js';
import bus from '@/common/eventBus.js';
import {store} from '@/vuex/store.js';
import commonMethods from '@/common/commonMethods.js';
import urls from '@/ws/api.js';
import Video from 'video.js';
import 'video.js/dist/video-js.css';

Vue.use(ElementUI);

import pcHeader from '@/components/pc/common/header/PcHeader.vue';
import pcFooter from '@/components/pc/common/footer/PcFooter.vue';
Vue.component('pcHeader', pcHeader); // pc端底部
Vue.component('pcFooter', pcFooter); // pc端底部
import appHeader from '@/components/mobile/common/header/AppHeader.vue';
import appFooter from '@/components/mobile/common/footer/AppFooter.vue';
Vue.component('appHeader', appHeader); // mobile端底部
Vue.component('appFooter', appFooter); // mobile端底部

Vue.config.productionTip = false;
Vue.prototype.$axios = _axios;
Vue.prototype.$urls = urls;
Vue.prototype.$bus = bus;
Vue.prototype.$cm = commonMethods;
Vue.prototype.$video = Video;

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { 
    App,
    pcFooter
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js